interface InputWrapperProps {
  label?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
  hasError?: boolean;
}

export function InputWrapper({
  label,
  description,
  children,
  hasError,
}: InputWrapperProps) {
  return (
    <div className="flex flex-col gap-y-1 w-full">
      {label && (
        <span
          className={`text-left text-sm ${
            hasError ? "text-red" : "text-gray-700"
          }`}
        >
          {label}
        </span>
      )}
      <div
        className={`col-span-3 border ${
          hasError ? "border-red" : "border-gray-200"
        } rounded-lg p-2 bg-white flex items-center`}
      >
        {children}
      </div>
      {description && (
        <span className="text-left text-xs text-gray-700">{description}</span>
      )}
    </div>
  );
}
